export const getOptionsFromEnum = (enumObj: any) => {
    let options = [];

    options.push({ value: "", label: "-" });

    for (const key in enumObj) {
        options.push({
            value: key,
            label: (enumObj as any)[key],
        });
    }
    return options;
};
